<!-- src/app/app.component.html -->
<!-- <div class="app-container" >
  <app-sidebar></app-sidebar>
  
  <div class="content-wrapper">
    <app-topbar></app-topbar>
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div> -->


<div class="app-container" *ngIf="loggedIn">
  <app-sidebar></app-sidebar>
  
  <div class="content-wrapper">
    <app-topbar></app-topbar>
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<div class="auth-container" *ngIf="!loggedIn">
  <router-outlet></router-outlet>
</div>